import React, { Component } from 'react'
import { t } from 'i18n'

class PaymentProcessingStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      warrant_check: props.warrant_check
    }
  }

  renderSpinner() {
    return (
      <span className='loading-indicator large'></span>
    )
  }

  renderSearchFields() {
    const { warrant_check } = this.state

    return (
      <div className='service-summary mt-4'>
        {warrant_check.search_criteria.map((field, index) =>
          <span key={index} className='service-summary-item'>{field}</span>
        )}
      </div>
    )
  }

  render() {
    return(
      <div className='processing-warrant service-form text-center'>
        {this.renderSpinner()}
        <h1 className='h4 text-center'>{t('components.warrant_check_container.processing_payment')}</h1>
        <p className='text-center small white-space-pre'>
          {t('components.warrant_check_container.processing_payment_info')}
        </p>
        {this.renderSearchFields()}
      </div>
    )
  }
}

export default PaymentProcessingStep
